import { render, staticRenderFns } from "./QuickTopic.vue?vue&type=template&id=7dfc9e7a&scoped=true"
import script from "./QuickTopic.vue?vue&type=script&lang=js"
export * from "./QuickTopic.vue?vue&type=script&lang=js"
import style0 from "./QuickTopic.vue?vue&type=style&index=0&id=7dfc9e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc9e7a",
  null
  
)

export default component.exports